module.exports = __webpack_public_path__ + "img/Saudi Arabia.55a6e2d4.svg";